<template>
  <div>
    <router-link v-for="subfolder in mailbox.subfolders" :key="subfolder.id" :to="{name: 'InboxSubfolder', params: { subfolder_id: subfolder.id } }"><li>{{subfolder.name}} <b-badge variant="light" pill> {{ mailbox.subfolders_count[subfolder.id] || 0 }} </b-badge></li></router-link>
  </div>
</template>

<script>
export default {
  name: 'SubFolders',
  props: ['mailbox']
}
</script>
<style scoped>
.filter-toggle a {
  margin-top: 5px;
  color: #fff;
  cursor: pointer;
}
.nav-team-header {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  width: 100%;
  font-size: 20px;
  display: block;
  background-color: #3D829A;
  cursor: pointer;
  text-align: left;
}
.nav-team-header.collapsed {
  background: #57B2CD;
}
.nav-team-header.collapsed:hover {
  background: rgb(84, 166, 193);
}
.nav-team-header .oi-chevron-top {
  transform: translateY(-2px);
  margin-left: 5px;
  font-size: 12px;
}
.nav-team-header.collapsed .oi-chevron-top {
  transform: translateY(-2px) rotateX(180deg);
}
.nav-team .card-body, .nav-team .card {
  background-color: #3D829A;
  padding: 0;
  border-top: none;
}
.nav-team .mt-2 {
  margin-top: 0px !important;
}
.card-body {
  margin-bottom: 10px;
}
.card-body ul {
  text-align: left;
  list-style: none;
  margin-bottom: 0px;
  margin-left: 0px;
  padding-left: 20px;
}
.card-body ul a {
  color: #fff;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Subfolders.vue